import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-5 sm:grid-cols-3" }

import InputArea from '@/components/neue/InputArea.vue'
import SelectInput from '@/components/neue/SelectInput.vue'
import SettingsSection from '@/components/neue/SettingsSection.vue'

import AgentToggleRow from './AgentToggleRow.vue'
import {
  DEFAULT_ENTHUSIASM,
  DEFAULT_FORMALITY,
  DEFAULT_TONE,
  ENTHUSIASM_OPTIONS,
  FORMALITY_OPTIONS,
  TONE_OPTIONS
} from './agentVoiceOptions'


export default {
  __name: 'AgentVoiceFields',
  props: {
  brandVoice: { type: String, default: '' },
  emoji: { type: Boolean, default: false },
  additionalContext: { type: String, default: '' },
  tone: { type: String, default: DEFAULT_TONE },
  formality: { type: String, default: DEFAULT_FORMALITY },
  enthusiasm: { type: String, default: DEFAULT_ENTHUSIASM }
},
  emits: [
  'update:brandVoice',
  'update:emoji',
  'update:additionalContext',
  'update:tone',
  'update:formality',
  'update:enthusiasm'
],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SettingsSection, {
      title: "Brand voice",
      description: "How your agents sound. This applies to every agent you run."
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(SelectInput, {
            "model-value": props.tone,
            name: "Tone",
            options: _unref(TONE_OPTIONS),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (emit('update:tone', $event)))
          }, null, 8, ["model-value", "options"]),
          _createVNode(SelectInput, {
            "model-value": props.formality,
            name: "Formality",
            options: _unref(FORMALITY_OPTIONS),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (emit('update:formality', $event)))
          }, null, 8, ["model-value", "options"]),
          _createVNode(SelectInput, {
            "model-value": props.enthusiasm,
            name: "Enthusiasm",
            options: _unref(ENTHUSIASM_OPTIONS),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (emit('update:enthusiasm', $event)))
          }, null, 8, ["model-value", "options"])
        ]),
        _createVNode(InputArea, {
          "model-value": props.brandVoice,
          name: "Brand voice summary",
          rows: "3",
          description: "A few words on how your brand talks, e.g. friendly, direct, a little playful.",
          "description-above": "",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (emit('update:brandVoice', $event)))
        }, null, 8, ["model-value"]),
        _createVNode(AgentToggleRow, {
          "model-value": props.emoji,
          label: "Use emoji",
          help: "Let your agents use emoji in replies.",
          class: "border-t border-gray-100 pt-5",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (emit('update:emoji', $event)))
        }, null, 8, ["model-value"])
      ]),
      _: 1
    }),
    _createVNode(SettingsSection, {
      title: "Context",
      description: "Notes every agent should keep in mind."
    }, {
      default: _withCtx(() => [
        _createVNode(InputArea, {
          "model-value": props.additionalContext,
          name: "Additional information",
          rows: "4",
          description: "Anything specific your agents should know, like dietary notes, hours, brand do's and don'ts.",
          "description-above": "",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (emit('update:additionalContext', $event)))
        }, null, 8, ["model-value"])
      ]),
      _: 1
    })
  ], 64))
}
}

}